var $ba19b07a1b9e5177$exports = {};
$ba19b07a1b9e5177$exports = {
  "collapse": "Sak\u013Caut",
  "expand": "Izv\u0113rst"
};
export { $ba19b07a1b9e5177$exports as default };